import storage from '@/utils/storage';

export function useSkin() {
  return storage.getSkin();
}
